import { IImportModel } from '../importer/model';

export const ancillaryGroundServicesRatesImportDomainSelector = (state: any): IImportModel =>
  state.ancillaryGroundServicesRatesImport as IImportModel;
